import React, { useContext, useEffect, useState } from "react"
import { Box, Button, Divider, InputLabel, Typography } from "@mui/material"
import toast from "react-hot-toast"
import { Paypal } from "../../pages/Paypal"
import { Link, useNavigate } from "react-router-dom"
import { GlobalContext } from "../../context/GlobalState"
import { CartService } from "../../services/cart-service"
import { PaymentService } from "../../services/payment-service"
import { BillingDetails } from "./BillingDetails"
import FormControl from "@mui/material/FormControl"
import NativeSelect from "@mui/material/NativeSelect"
import { useCallback } from "react"
import { useMemo } from "react"
import StripeModal from "../modal/StripeModal"
import NewAddressModal from "../modal/NewAddressModal"
import { userPaymentKey } from "../../services/get-user-payment-publish-key"
import { Container } from "@mui/system"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
export const CheckoutTwo = () => {
  const navigate = useNavigate()
  const [clientSecret, setClientSecret] = useState("")
  const [shippingAddress, setShippingAddress] = useState({})
  const [billingAddress, setBillingAddress] = useState({})
  const [customerDetails, setCustomerDetails] = useState({})
  const [open, setOpen] = useState(false)
  const [keyId, setKeyId] = useState(null)
  const [paypalObj, setPaypalObj] = useState(null)
  const [publishKey, setPublishKey] = useState(null)
  const [vendor_id, setVendor_id] = useState(window.config.vendor_id)
  const { emptyCart } = useContext(GlobalContext)
  const cart = JSON.parse(localStorage.getItem("cartItems"))
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const addressDetailsFn = useCallback(
    (address) => {
      const billingDetails = [
        {
          addressName: "Bill to",
          addressValue: address?.address_name || "",
        },
        {
          addressName: "Company name",
          addressValue: address?.company_name || "",
        },
        {
          addressName: "Tax id",
          addressValue: address?.tax_id || "",
        },
        {
          addressName: "Address",
          addressValue: joinWithCommas([
            address?.address_line_1,
            address?.address_line_2,
            address?.city,
            customerDetails?.states?.find(
              (state) => state.id === address?.state_id
            )?.name,
            customerDetails?.countries?.find(
              (country) => country.id === address?.country_id
            )?.name,
            address?.postalcode,
          ]),
        },
        {
          addressName: "Email",
          addressValue: address?.email || "",
        },
        {
          addressName: "Phone",
          addressValue: address?.phone || "",
        },
      ]
      return billingDetails
    },
    [customerDetails]
  )

  function joinWithCommas(arr) {
    return arr.filter(Boolean).join(", ")
  }
  const sumPrice = useMemo(() => {
    return cart?.reduce((total, item) => {
      if (item.total_selling_price === 0 || item.total_selling_price === "0") {
        return total + parseFloat(item.total_selling_price)
      } else {
        return total + parseFloat(item.total_selling_price.replace(/,/g, ""))
      }
    }, 0)
  }, [cart])

  const saveStoneList = async () => {
    // e.preventDefault()
    let isVendor = localStorage.getItem("user_type") === "vendor"
    // let url         = `${window.config.api_url}/save-stone-list`
    let data = {
      stone_ids: cart.map((cartItem) => {
        return cartItem.id
      }),
      user_id: vendor_id,
      customer_billing_id: billingAddress.id,
      customer_id: isVendor ? null : localStorage.getItem("user_id"),
      customer_shipping_id: shippingAddress.id,
      user_type:
        localStorage.getItem("user_type") === null
          ? "vendor"
          : localStorage.getItem("user_type"),
      payment_format: cart
        .map((cartItem) => {
          return cartItem.currency_format
        })[0]
        .toString(),
    }

    await CartService.completedCart(data).then((res) => {
      if (res.data.success) {
        localStorage.setItem("invoice_id", res.data.id)
        localStorage.setItem("cartItems", JSON.stringify([]))
        emptyCart()
        navigate("/thankyou-quote")
      } else {
        toast.error("Something went wrong. Please try again later!")
      }
    })
  }

  const handleAddressChange = (e) => {
    const { name, value } = e.target
    if (name === "billingAddress") {
      const add = customerDetails.shipping_addresses.find(
        (singleAddress) => singleAddress.id.toString() === value
      )
      setBillingAddress(add)

      localStorage.setItem(
        "billingAddress",
        JSON.stringify(
          customerDetails.shipping_addresses.find(
            (singleAddress) => singleAddress.id.toString() === e.target.value
          )
        )
      )
    } else if (name === "shippingAddress") {
      setShippingAddress(
        customerDetails.shipping_addresses.find(
          (singleAddress) => singleAddress.id.toString() === e.target.value
        )
      )
      localStorage.setItem(
        "shippingAddress",
        JSON.stringify(
          customerDetails.shipping_addresses.find(
            (singleAddress) => singleAddress.id.toString() === e.target.value
          )
        )
      )
    }
  }
  const getClientSecret = () => {
    PaymentService.getClientSecret({
      amount: sumPrice,
      vendor_id: window.config.vendor_id,
      currency: cart[0]?.currency_logo,
    })
      .then((res) => {
        if (res.data.success) {
          setClientSecret(res.data.result.client_secret)
          setPublishKey(res.data.published_key)
        }
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    setCustomerDetails(JSON.parse(localStorage.getItem("customer")))
  }, [])

  useEffect(() => {
    setBillingAddress(
      customerDetails?.shipping_addresses?.find(
        (singleAddress) => singleAddress.default
      )
    )

    setShippingAddress(
      customerDetails?.shipping_addresses?.find(
        (singleAddress) => singleAddress.default
      )
    )
  }, [customerDetails])
  useEffect(() => {
    setTimeout(() => {
      localStorage.setItem(
        "billingAddress",
        JSON.stringify(
          customerDetails?.shipping_addresses?.find(
            (singleAddress) => singleAddress.default
          )
        )
      )
    }, "2000")

    setTimeout(() => {
      localStorage.setItem(
        "shippingAddress",
        JSON.stringify(
          customerDetails?.shipping_addresses?.find(
            (singleAddress) => singleAddress.default
          )
        )
      )
    }, "2000")
  }, [customerDetails])
  const getpaymentKey = async () => {
    const response = await userPaymentKey({
      user_id:
        localStorage.getItem("user_id") === null
          ? window.config.vendor_id
          : localStorage.getItem("user_id"),
      user_type:
        localStorage.getItem("user_type") === null
          ? "vendor"
          : localStorage.getItem("user_type"),
    })
    const paymentKeys = response?.data?.data
    setKeyId(paymentKeys)
    if (paymentKeys) {
      const paypalKey = paymentKeys.find((key) => key.payment_type === "paypal")
      if (paypalKey) {
        setPaypalObj(paypalKey)
      }
    }
  }

  useEffect(() => {
    getpaymentKey()
    getClientSecret()
  }, [])

  if (cart.length === 0) {
    navigate("/products/1,4")
  }
  return (
    <Container
      sx={{
        "&.MuiContainer-root ": {
          p: 0,
          maxWidth: "1214px",
        },
      }}
    >
      <Box
        sx={{ mt: { xs: "24px", md: "48px" }, mx: { xs: "12px", lg: "0px" } }}
      >
        <Typography
          sx={{
            fontWeight: "700",
            fontSize: { xs: "32px", md: "36px" },
            textAlign: "center",
            fontFamily: "KaiseiDecol-Regular",
          }}
        >
          Checkout
        </Typography>
        <Box sx={{ mt: "24px", backgroundColor: " #F8F8F8" }}>
          <Box sx={{ p: { xs: "16px", md: "24px" } }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "24px",
                  fontFamily: "KaiseiDecol-Regular",
                }}
              >
                Address details
              </Typography>

              <Button
                size='small'
                sx={{
                  bgcolor: "black",
                  color: "white",
                  fontSize: { mobile: "14px", laptop: "16px" },
                  textTransform: "lowercase",

                  // mt: "16px",
                  px:"0.6rem",
                  "&.MuiButton-root:hover": {
                    color: " white",
                    bgcolor: "#333333",
                    borderColor: " #333333",
                  },
                  fontFamily: "mulish-regular",
                  "& .capitalize-first": {
                    "&::first-letter": {
                      textTransform: "uppercase",
                    },
                  },
                }}
                onClick={handleOpen}
              >
                <span className='capitalize-first'>Add new address</span>
              </Button>
            </Box>
            {/* <NewAddressModal setCustomerDetails={setCustomerDetails} /> */}
            <Box sx={{ border: "1px solid #E0E0E0", mt: "16px" }} />
            <Box
              sx={{
                display: { sm: "flex" },
                justifyContent: "space-between",
                mt: "16px",
              }}
            >
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    display: { sm: "flex" },
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      color: " #333333",
                      fontWeight: 700,
                      fontSize: "20px",
                      fontFamily: "KaiseiDecol-Regular",
                    }}
                  >
                    Billing address
                  </Typography>

                  <Box
                    sx={{
                      minWidth: { xs: 30, md: " 180px" },
                      mt: { xs: "8px ", md: "0px" },
                    }}
                  >
                    <FormControl fullWidth>
                      <NativeSelect
                        sx={{
                          "&.MuiInput-root:before": {
                            border: "none",
                          },
                          "&.MuiInput-root:after": {
                            border: "none",
                          },
                          "&.MuiInputBase-root:hover:not(.Mui-disabled):before":
                            {
                              border: "none",
                            },
                          border: "1px solid #E0E0E0",
                          bgcolor: "white",
                          px: "12px",
                          fontFamily: "mulish-regular",
                          borderRadius: "2px",
                          py: "2px",
                        }}
                        name='billingAddress'
                        defaultValue={billingAddress?.id}
                        onChange={handleAddressChange}
                      >
                        {customerDetails?.shipping_addresses?.length !== 0 ? (
                          customerDetails?.shipping_addresses?.map(
                            (singleAddress, index) => {
                              return (
                                <option key={index} value={singleAddress.id}>
                                  {singleAddress.address_name}
                                </option>
                              )
                            }
                          )
                        ) : (
                          <></>
                        )}
                      </NativeSelect>
                    </FormControl>
                  </Box>
                </Box>
                <BillingDetails
                  title={"Billing"}
                  billingDetails={addressDetailsFn(billingAddress)}
                />
              </Box>
              <Box
                sx={{ border: "1px solid #E0E0E0", mt: "16px", mx: "32px" }}
              />
              {/* <Box>
              <Divider sx={{ borderColor: "black" }} />
            </Box> */}
              <Box sx={{ mt: { xs: "32px", md: "0px" }, width: "100%" }}>
                <Box
                  sx={{
                    display: { sm: "flex" },
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      color: " #333333",
                      fontWeight: 700,
                      fontSize: "20px",
                      fontFamily: "KaiseiDecol-Regular",
                    }}
                  >
                    Shipping address
                  </Typography>

                  <Box
                    sx={{
                      minWidth: { xs: 30, md: " 180px" },
                      mt: { xs: "8px ", md: "0px" },
                    }}
                  >
                    <FormControl fullWidth>
                      <NativeSelect
                        sx={{
                          "&.MuiInput-root:before": {
                            border: "none",
                          },
                          "&.MuiInput-root:after": {
                            border: "none",
                          },
                          "&.MuiInputBase-root:hover:not(.Mui-disabled):before":
                            {
                              border: "none",
                            },
                          border: "1px solid #E0E0E0",
                          bgcolor: "white",
                          px: "12px",
                          fontFamily: "mulish-regular",
                          borderRadius: "2px",
                          py: "2px",
                        }}
                        name='shippingAddress'
                        defaultValue={shippingAddress?.id}
                        onChange={handleAddressChange}
                        // sx={{border:"1px solid black"}}
                      >
                        {customerDetails?.shipping_addresses?.length !== 0 ? (
                          customerDetails?.shipping_addresses?.map(
                            (singleAddress, index) => (
                              <option key={index} value={singleAddress.id}>
                                {singleAddress.address_name}
                              </option>
                            )
                          )
                        ) : (
                          <></>
                        )}
                      </NativeSelect>
                    </FormControl>
                  </Box>
                </Box>
                <BillingDetails
                  billingDetails={addressDetailsFn(shippingAddress)}
                />
              </Box>
            </Box>
            {/* address ends here */}
            <Box></Box>
            {/* secure services */}
          </Box>
        </Box>
        <Box
          sx={{
            display: { sm: "none", md: "flex" },
            justifyContent: "space-between",
            mt: "24px",
            mx: "24px",
            // columnGap:"1rem"
          }}
        >
          <Box sx={{ width: "49%",  lineHeight:"24px"}}>
            <AssuranceCard
              img={"/images/secure-service.png"}
              AssuranceType={"Secure service"}
              // AssuranceDiscription={
              //   "I'll take a dram of dram small batch single barrel blantons glenlivet pot still glenmorangie! pot still single barrel barrel red breast malt whiskey dram scotland? "
              // }
            />
          </Box>
          <Box sx={{ width: "49%", mt: { xs: "1rem", md: "0rem" } }}>
            <AssuranceCard
              sx={{
                backgroundColor:"red",
                fontSize: "50px", // Set the font size here
              }}
              img={"/images/money-back-guarantee.png"}
              AssuranceType={"Money back guarantee "}
              // AssuranceDiscription={
              //   "I'll take a dram of dram small batch single barrel blantons glenlivet pot still glenmorangie! "
              // }
            />
          </Box>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            mr: { md: "2rem" },
            mt: "24px",
            display: { sm: "block", md: "none" },
          }}
        >
          <ItemDetails
            cart={cart}
            sumPrice={sumPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              onClick={() => navigate("/products/1,4")}
              sx={{
                color: "black",
                fontSize: "16px",
                textTransform: "lowercase",
                fontWeight: "18px",
                fontWeight: 400,
                color: "#333333",
                p: "6px 3px",
                // p:"4rem",
                fontFamily: "mulish-regular",
                mt: "14px",
                "&.MuiButton-root:hover": {
                  color: " #1A1A1A",
                  bgcolor: "white",
                },
                "& .capitalize-first": {
                  "&::first-letter": {
                    textTransform: "uppercase",
                  },
                },
              }}
              startIcon={
                <ChevronLeftIcon
                  sx={{
                    bgcolor: " #1A1A1A",
                    fontSize: "10px",
                    color: "white",
                    borderRadius: "4px",
                  }}
                />
              }
            >
              <span style={{fontSize:"18px"}} className='capitalize-first'>Continue shopping</span>
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: { sm: "flex" },
            alignItems: "flex-start",
            justifyContent: "space-between",
            mt: "24px",
            // height:"100%"
          }}
        >
          <Box
            sx={{
              display: { xs: "none", sm: "block", md: "none" },
              justifyContent: "space-between",
              // mt: "24px",
              mx: "24px",
              // columnGap: "1rem",
            }}
          >
            <AssuranceCard
              img={"/images/secure-service.png"}
              AssuranceType={"Secure service"}
              // AssuranceDiscription={
              //   "I'll take a dram of dram small batch single barrel blantons glenlivet pot still glenmorangie! pot still single barrel barrel red breast malt whiskey dram scotland? "
              // }
            />
            <Box sx={{ mt: { xs: "1rem", md: "0rem" } }}>
              <AssuranceCard
                img={"/images/money-back-guarantee.png"}
                AssuranceType={"Money back guarantee "}
                // AssuranceDiscription={
                //   "I'll take a dram of dram small batch single barrel blantons glenlivet pot still glenmorangie! "
                // }
              />
            </Box>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              mr: "2rem",
              display: { xs: "none", md: "block" },
            }}
          >
            <ItemDetails
              cart={cart}
              sumPrice={sumPrice
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                onClick={() => navigate("/products/1,4")}
                sx={{
                  color: "black",
                  fontSize: "16px",
                  textTransform: "lowercase",
                  fontWeight: "18px",
                  fontWeight: 400,
                  color: "#333333",
                  fontFamily: "mulish-regular",
                  mt: "14px",
                  p: "6px 3px",
                  "&.MuiButton-root:hover": {
                    color: " #1A1A1A",
                    bgcolor: "white",
                  },
                  "& .capitalize-first": {
                    "&::first-letter": {
                      textTransform: "uppercase",
                    },
                  },

                  // p:0,
                  // m:0
                }}
                startIcon={
                  <ChevronLeftIcon
                    sx={{
                      bgcolor: " #1A1A1A",
                      fontSize: "10px",
                      color: "white",
                      borderRadius: "4px",
                    }}
                  />
                }
              >
                <span style={{fontSize:"18px"}}  className='capitalize-first'>Continue shopping</span>
              </Button>
            </Box>
          </Box>

          <PaymentDetails
            sumPrice={sumPrice}
            logo={cart[0]?.currency_logo}
            cart={cart}
            clientSecret={clientSecret}
            getClientSecret={getClientSecret}
            saveStoneList={saveStoneList}
            paypalObj={paypalObj}
          />
        </Box>
        <StripeModal clientSecret={clientSecret} publishKey={publishKey} />
        <NewAddressModal
          open={open}
          handleClose={handleClose}
          handleOpen={handleOpen}
          setCustomerDetails={setCustomerDetails}
        />
      </Box>
    </Container>
  )
}

export const PaymentDetails = ({
  sumPrice,
  logo,
  cart,
  clientSecret,
  getClientSecret,
  saveStoneList,
  paypalObj,
}) => {
  const paymentDetail = (type, price) => {
    return (
      <>
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: "18px",
            color: "#333333",
            lineHeight:"26px",
            fontFamily: "mulish-regular",
          }}
        >
          {type}:
        </Typography>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "18px",
            color: type === "Discount" ? "red" : "#333333",
            fontFamily: "mulish-regular",
          }}
        >
          {logo}
          {price}
        </Typography>
      </>
    )
  }
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F8F8F8",
          py: "16px",
          px: "24px",
          width: { md: "389px" },
          height: "532px",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "24px",
              fontFamily: "KaiseiDecol-Regular",
            }}
          >
            Payment
          </Typography>
          <Box sx={{ border: "1px solid #E0E0E0", mt: "16px" }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "16px",
            }}
          >
            {paymentDetail(
              "Sub-total",
              sumPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            )}
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "12px",
            }}
          >
            {paymentDetail("Discount", "0.00")}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "12px",
            }}
          >
            {paymentDetail("Shipping", "0.00")}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "12px",
            }}
          >
            {paymentDetail("Taxes", "0.00")}
          </Box> */}
          <Box sx={{ border: "1px solid #E0E0E0", mt: "16px" }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "12px",
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                fontWeight: 700,
                color: " #333333",
                fontFamily: "KaiseiDecol-Regular",
              }}
            >
              Total:
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                fontWeight: 700,
                color: " #333333",
                fontFamily: "KaiseiDecol-Regular",
              }}
            >
              {logo}
              {sumPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", mt: "16px" }}>
            <Button
              onClick={() => {
                if (cart.length !== 0) saveStoneList()
                else toast.error("No Items in Cart...")
              }}
              sx={{
                bgcolor: "black",
                color: "white",
                fontSize: "16px",
                height: "42px",

                textTransform: "lowercase",
                fontFamily: "mulish-regular",
                mt: "8px",
                "&.MuiButton-root:hover": {
                  color: " white",
                  bgcolor: "#333333",
                  borderColor: " #333333",
                },
                "& .capitalize-first": {
                  "&::first-letter": {
                    textTransform: "uppercase",
                  },
                },
              }}
            >
              <span className='capitalize-first'> get a quote</span>
            </Button>
            {/* <Button
              variant='outlined'
              sx={{
                // bgcolor: "black",
                color: "black",
                fontSize: "16px",
                height: "42px",
                mt: "8px",
                textTransform: "lowercase",
                borderColor: "#1A1A1A",
                fontFamily: "mulish-regular",
                "&.MuiButton-root:hover": {
                  color: " white",
                  bgcolor: "#333333",
                  borderColor: " #333333",
                },
                "& .capitalize-first": {
                  "&::first-letter": {
                    textTransform: "uppercase",
                  },
                },
              }}
            >
              <span className='capitalize-first'> make an offer</span>
            </Button> */}
          </Box>
          {paypalObj && sumPrice !== 0 && (
            <Typography
              sx={{
                textAlign: "center",
                mt: "8px",
                fontFamily: "mulish-regular",
              }}
            >
              or
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "8px",
              mb: "16px",
            }}
          >
            {clientSecret && (
              <Button
                sx={{
                  // color: "#e9f3fb",
                  bgcolor: "#6772e5",
                  height: "2.5rem",
                  boxShadow: "none",
                  "&:hover": {
                    // color: "#e9f3fb",
                    bgcolor: "#6772e5",
                  },
                  width: "154px",
                  mr: "1rem",
                }}
                variant='contained'
                data-bs-toggle={
                  cart.length !== 0 ||
                  localStorage.getItem("user_type") !== "vendor"
                    ? "modal"
                    : ""
                }
                data-bs-target={
                  cart.length !== 0 ||
                  localStorage.getItem("user_type") !== "vendor"
                    ? "#stripeModal"
                    : ""
                }
                onClick={() => {
                  if (localStorage.getItem("user_type") !== "vendor") {
                    if (cart.length !== 0) getClientSecret()
                    else toast.error("No Items in Cart...")
                  }
                }}
              >
                <svg
                  width='100px'
                  height='24px'
                  viewBox='0 0 512 214'
                  version='1.1'
                  xmlns='http://www.w3.org/2000/svg'
                  xlink='http://www.w3.org/1999/xlink'
                  preserveAspectRatio='xMidYMid'
                >
                  <g>
                    <path
                      d='M35.9822222,83.4844444 C35.9822222,77.9377778 40.5333333,75.8044444 48.0711111,75.8044444 C58.88,75.8044444 72.5333333,79.0755556 83.3422222,84.9066667 L83.3422222,51.4844444 C71.5377778,46.7911111 59.8755556,44.9422222 48.0711111,44.9422222 C19.2,44.9422222 0,60.0177778 0,85.1911111 C0,124.444444 54.0444444,118.186667 54.0444444,135.111111 C54.0444444,141.653333 48.3555556,143.786667 40.3911111,143.786667 C28.5866667,143.786667 13.5111111,138.951111 1.56444444,132.408889 L1.56444444,166.257778 C14.7911111,171.946667 28.16,174.364444 40.3911111,174.364444 C69.9733333,174.364444 90.3111111,159.715556 90.3111111,134.257778 C90.1688889,91.8755556 35.9822222,99.4133333 35.9822222,83.4844444 Z M132.124444,16.4977778 L97.4222222,23.8933333 L97.28,137.813333 C97.28,158.862222 113.066667,174.364444 134.115556,174.364444 C145.777778,174.364444 154.311111,172.231111 159.004444,169.671111 L159.004444,140.8 C154.453333,142.648889 131.982222,149.191111 131.982222,128.142222 L131.982222,77.6533333 L159.004444,77.6533333 L159.004444,47.36 L131.982222,47.36 L132.124444,16.4977778 Z M203.235556,57.8844444 L200.96,47.36 L170.24,47.36 L170.24,171.804444 L205.795556,171.804444 L205.795556,87.4666667 C214.186667,76.5155556 228.408889,78.5066667 232.817778,80.0711111 L232.817778,47.36 C228.266667,45.6533333 211.626667,42.5244444 203.235556,57.8844444 Z M241.493333,47.36 L277.191111,47.36 L277.191111,171.804444 L241.493333,171.804444 L241.493333,47.36 Z M241.493333,36.5511111 L277.191111,28.8711111 L277.191111,0 L241.493333,7.53777778 L241.493333,36.5511111 Z M351.431111,44.9422222 C337.493333,44.9422222 328.533333,51.4844444 323.555556,56.0355556 L321.706667,47.2177778 L290.417778,47.2177778 L290.417778,213.048889 L325.973333,205.511111 L326.115556,165.262222 C331.235556,168.96 338.773333,174.222222 351.288889,174.222222 C376.746667,174.222222 399.928889,153.742222 399.928889,108.657778 C399.786667,67.4133333 376.32,44.9422222 351.431111,44.9422222 Z M342.897778,142.933333 C334.506667,142.933333 329.528889,139.946667 326.115556,136.248889 L325.973333,83.4844444 C329.671111,79.36 334.791111,76.5155556 342.897778,76.5155556 C355.84,76.5155556 364.8,91.0222222 364.8,109.653333 C364.8,128.711111 355.982222,142.933333 342.897778,142.933333 Z M512,110.08 C512,73.6711111 494.364444,44.9422222 460.657778,44.9422222 C426.808889,44.9422222 406.328889,73.6711111 406.328889,109.795556 C406.328889,152.604444 430.506667,174.222222 465.208889,174.222222 C482.133333,174.222222 494.933333,170.382222 504.604444,164.977778 L504.604444,136.533333 C494.933333,141.368889 483.84,144.355556 469.76,144.355556 C455.964444,144.355556 443.733333,139.52 442.168889,122.737778 L511.715556,122.737778 C511.715556,120.888889 512,113.493333 512,110.08 Z M441.742222,96.5688889 C441.742222,80.4977778 451.555556,73.8133333 460.515556,73.8133333 C469.191111,73.8133333 478.435556,80.4977778 478.435556,96.5688889 L441.742222,96.5688889 L441.742222,96.5688889 Z'
                      fill='#ffff'
                    ></path>
                  </g>
                </svg>
              </Button>
            )}

            <Paypal paypalObj={paypalObj} sumPrice={sumPrice} />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export const ItemDetails = ({ cart, sumPrice }) => {
  return (
    <Box
      sx={{
        px: "24px",
        py: "16px",
        // width: { md: "100%" },
        border: "1px solid #E0E0E0",
        // minHeight: "332px",
        // overflowY: "auto",
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 700,

            color: " #333333",
            fontFamily: "KaiseiDecol-Regular",
          }}
        >
          Item details
        </Typography>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            // textAlign: { xs: "left", md: "left" },
            fontFamily: "KaiseiDecol-Regular",
            color: " #333333",
          }}
        >
          {cart.length === 1 || cart.length === 0
            ? cart.length + " item"
            : cart.length + " items"}
        </Typography>
      </Box>
      <Box sx={{ border: "1px solid #E0E0E0", mt: "16px" }} />
      <ItemDetailCard cart={cart} />
      <Box sx={{ border: "1px solid #E0E0E0", mt: "1rem" }} />
      <Box sx={{ display: "flex ", justifyContent: "end", mt: "1rem" }}>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 400,
            fontFamily: "mulish-regular",
          }}
        >
          Total items price &nbsp;
          <Typography
            component='span'
            sx={{
              fontWeight: 600,
              fontSize: "18px",
              fontFamily: "mulish-regular",
            }}
          >
            ${sumPrice}
          </Typography>
        </Typography>
      </Box>
    </Box>
  )
}

export const ItemDetailCard = ({ cart }) => {
  return (
    <>
      {cart?.map((item) => {
        return (
          <Box
            key={item?.id}
            sx={{
              display: "flex",
              //   justifyContent: "space-between",
              justifyContent: "space-between",
              //   mx: "16px",
              mt: "16px",
            }}
          >
            <Box sx={{ width: { xs: "125px", md: "183px" } }}>
              <Box
                component='img'
                src={item.image}
                alt={item.internal_reference_number}
                sx={{ width: { xs: "125px", md: "183px" }, height: "136px" }}
              />
            </Box>
            <Box sx={{ width: "488px", ml: "16px", width: "100%" }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#333333",
                  mt: "6.5px",
                  fontFamily: "KaiseiDecol-Regular",
                }}
              >
                {item?.stone_types ? item?.stone_types : "Unnamed"}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: " #858585",
                  my: "4px",
                  fontFamily: "mulish-regular",
                }}
              >
                Ref#:&nbsp;
                {item?.internal_reference_number}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#333333",
                  my: "4px",
                  fontFamily: "mulish-regular",
                }}
              >
                Weight:&nbsp;
                <Typography
                  component='span'
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    fontFamily: "mulish-regular",
                  }}
                >
                  {item?.weight + item?.weight_type}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: " #333333",
                  my: "4px",
                  fontFamily: "mulish-regular",
                }}
              >
                Origin:&nbsp;
                <Typography
                  component='span'
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    fontFamily: "mulish-regular",
                  }}
                >
                  {item?.countries}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#333333",
                  my: "4px",
                  fontFamily: "mulish-regular",
                }}
              >
                Treatment:&nbsp;
                <Typography
                  component='span'
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    fontFamily: "mulish-regular",
                  }}
                >
                  {item?.stone_type_treatments}
                </Typography>
              </Typography>
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                justifyContent: "end",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  fontFamily: "KaiseiDecol-Regular",
                }}
              >
                {item.currency_logo + item.total_selling_price}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </>
  )
}

export const AssuranceCard = ({ img, AssuranceType }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <Box component='img' src={img} />
      <Box sx={{ width: { xl: "504px" } }}>
        <Typography
          sx={{
            fontWeight: 700,
            color: "#333333",
            fontFamily: "mulish-regular",
          }}
        >
          {AssuranceType}
        </Typography>
        {/* <Typography
          sx={{
            mt: "4px",
            fontWeight: 500,
            color: "#333333",
            fontFamily: "mulish-regular",
          }}
        >
          {AssuranceDiscription}
        </Typography> */}
      </Box>
    </Box>
  )
}
